import { PlanBadgeComponent } from '@/global/plan-badge.component';
import { UserTagComponent } from '@/global/user-tag.component';
import { BinderService } from '@/services/api/binder.service';
import { ClientService } from '@/services/api/client.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { BinderTagsService } from '@/services/app/binder-tags.service';
import { UserAccessService } from '@/services/app/user-access.service';
import { CommonModule } from '@angular/common';
import { Component, effect, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { Binder, BinderTag } from 'src/app/models/binder.model';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-binder-site',
  imports: [
    FormsModule, 
    InputTextModule, 
    ButtonModule, 
    RippleModule, 
    PlanBadgeComponent, 
    UserTagComponent, 
    TagModule, 
    SkeletonModule, 
    CommonModule, 
    IconFieldModule, 
    InputIconModule,
    SelectModule
  ],
  template: `
<div class="card flex flex-col gap-4 mb-4" style="margin-bottom: 1rem;">
    <h2 class="text-900 flex align-items-center">
    <p-iconfield *ngIf="unlockJobEdit">
    <input pInputText type="text" class="text-2xl font-bold w-full" pSize="large" [(ngModel)]="newClientName" />
    <p-inputicon styleClass="pi pi-spinner pi-spin" *ngIf="loading" />
</p-iconfield>
        <span *ngIf="!unlockJobEdit" class="text-2xl font-bold">{{getJobNumber()}}</span>
        <button pButton pRipple *ngIf="userAccessService.binderEditAccess() && unlockJobEdit" (click)="loadHubspotName()"
            type="button" icon="pi pi-sync" class="p-button-rounded p-button-text ml-2"></button>
        <button pButton pRipple *ngIf="userAccessService.binderEditAccess()" (click)="toggleJobEdit()" type="button"
            [icon]="unlockJobEdit ? 'pi pi-times' : 'pi pi-pencil'"
            class="p-button-rounded p-button-text ml-2"></button>
        <button pButton pRipple *ngIf="userAccessService.binderEditAccess() && unlockJobEdit" (click)="saveClientName()"
            type="button" icon="pi pi-check" class="p-button-rounded p-button-text ml-2"></button>
    </h2>
    <div class="grid grid-cols-12 gap-2">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Site</label>
        <button pButton [severity]="'secondary'" (click)="openCriteriaEditor()" style="justify-content: flex-start !important;" [disabled]="!userAccessService.binderEditAccess()" class="col-span-12 md:col-span-9 ml-2 border-round shadow p-2 mb-1 text-left" style="border-radius: var(--border-radius);">
            <div class="flex justify-between items-center w-full">
                <div class="flex-1 text-left">
                    <div class="block text-900 text-left mb-1">{{binderService.currentBinder().SiteAddress}}</div>
                    <div class="block text-900 text-left">{{binderService.currentBinder().SiteCity}},
                        {{binderService.currentBinder().SiteState}} {{binderService.currentBinder().SiteZip}}</div>
                </div>
                <div class="flex items-center ml-2 mr-2" *ngIf="userAccessService.binderEditAccess()">
                    <i class="pi pi-pencil" style="color:var(--primary-color);"></i>
                </div>
            </div>
</button>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Plan</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="border-round shadow p-2 mb-1 text-left" style="border-radius: var(--border-radius);">
                <app-plan-badge [plan]="binderService.currentBinder().Plans"></app-plan-badge>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Orientation</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
                <p-select [options]="orientations" [(ngModel)]="orientation" (onChange)="changeOrientation($event.value)" class="w-full" [disabled]="!userAccessService.binderEditAccess()"></p-select>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Binder Title</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
            <input type="text" pInputText [disabled]="!userAccessService.binderEditAccess()"
                [(ngModel)]="title" (ngModelChange)="onTitleChange($event)"
                placeholder="Name this binder"
                pSize="large"
                class="w-full"
                />
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Location</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
                {{binderService.currentBinder().Franchises_Binders_SelectedFIDToFranchises.CityCode}}</div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Consultant</label>
        <div class="col-span-12 md:col-span-9">
            <app-user-tag [user]="binderService.currentBinder().Users"></app-user-tag>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Status</label>
        <div class="col-span-12 md:col-span-9">
            <p-tag *ngFor="let tag of binderTagsService.currentBinderTag()" [severity]="tag.color" [icon]="tag.icon"
                [value]="tag.name" (click)="onTagClick(tag)" class="mr-2"/>
                
        </div>
    </div>
</div>
    `,
})
export class BinderSiteComponent implements OnDestroy {
  authorImage: string = ';'
  newClientName: string = '';
  unlockJobEdit: boolean = false;
  exemptionStatus: boolean | null = null;
  pending: boolean | null = null;
  loading: boolean = false;
  title: string = '';
  private debounceTimer: any;
  orientations: string[] = ["Standard (Garage Right)", "Reversed (Garage Left)", "Standard", "Reversed"]
  orientation: string = '';

  constructor(
    public binderService: BinderService,
    private binderDialogService: BinderDialogService,
    public userAccessService: UserAccessService,
    public binderTagsService: BinderTagsService,
    private clientService: ClientService
  ) {
    effect(() => {
      const binder = this.binderService.currentBinder();
      const clientName = binder.ClientLastName;
      if (clientName) {
        this.setClientName(clientName);
      }
      if(binder.Title) {
        this.title = binder.Title;
      }
      if(binder.Orientation) {
        this.orientation = binder.Orientation;
      }
    });
  }

  updateBinder(binder: Partial<Binder>) {
    this.binderService.updateBinder(this.binderService.currentBinder().BinderID, binder).subscribe((updatedBinder) => {
      this.binderService.patchBinder(updatedBinder);
      this.loading = false;
    });
  }

  changeOrientation(orientation: string) {
    this.orientation = orientation;
    this.updateBinder({ Orientation: orientation });
  }

  toggleJobEdit() {
    this.unlockJobEdit = !this.unlockJobEdit;
    if (!this.unlockJobEdit) {
      this.setClientName(this.binderService.currentBinder().ClientLastName);
    }
  }

  loadHubspotName() {
    this.loading = true;
    if(this.binderService.currentBinder()?.Clients?.hsId) {
      const hsId = this.binderService.currentBinder()?.Clients?.hsId;
      if(hsId) {
        this.clientService.loadHubspotClient(parseInt(hsId)).subscribe((client) => {
          const name = client.contacts.find((contact) => contact.primary)?.properties.lastname;
          if(name) {
            this.newClientName = name;
          }
        });
      }
    };
    this.loading = false;
  }

  onTitleChange(value: string) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.updateBinder({ Title: value });
    }, 500);
  }

  openCriteriaEditor() {
    this.binderDialogService.toggleDialog('Design Criteria', 'design', true);
  }

  setClientName(clientName: string) {
    this.newClientName = clientName;
    this.unlockJobEdit = false;
  }

  saveClientName() {
    this.loading = true;
    console.log('saving ', this.newClientName);
    this.updateBinder({ ClientLastName: this.newClientName })
    this.unlockJobEdit = false;
  }

  toggleExemptionDialog() {
    this.binderDialogService.toggleDialog('Respond to exemption request', 'exResponse', true);
  }

  onJobChange(event: any) {
    console.log(event);
  }

  onTagClick(tag: BinderTag) {
    console.log(tag);
    switch (tag.type) {
      case 'exemption':
        this.toggleExemptionDialog();
        break;
    }
  }

  getJobNumber() {
    let number = '';
    const binder = this.binderService.currentBinder();
    if (binder?.JobNumber) {
      number = binder?.JobNumber.toString();
    } else {
      const extended = '0000' + binder.BinderID.toString();
      const suffix = extended.substring(extended.length - 6);
      number = binder.Franchises_Binders_SelectedFIDToFranchises.Code + suffix;
    }
    if (this.unlockJobEdit) {
      return ' - ' + number;
    } else {
      return binder.ClientLastName + ' - ' + number;
    }
  }

  ngOnDestroy() {
    clearTimeout(this.debounceTimer);
  }


}

